import { types as identityTypes } from '@clearscore/redux.identity';
import { types as marketTypes } from '@clearscore/redux.market';
import { types as productsTypes } from '@clearscore/redux.products';
import { types as profileTypes } from '@clearscore/redux.profile';
import { types as sessionTypes } from '@clearscore/redux.session';
import { types as trackingTypes } from '@clearscore/redux.webapp-tracking-actions';
import { types as alertsTypes } from '@clearscore/redux.alerts';

export default [
    identityTypes.IDENTITY_FIRST_TIME_REGISTRATION,
    identityTypes.IDENTITY_VERIFY_TOKEN_SUCCESS,
    marketTypes.MARKET_SET_ACTIVE_MARKET,
    marketTypes.MARKET_FETCH_CONFIG_SUCCESS,
    marketTypes.MARKET_SET_ACTIVE_LOCALE,
    productsTypes.STORE_RESULTS_REQUEST_DATA,
    profileTypes.PROFILE_FETCH_SUCCESS,
    sessionTypes.LOGOUT_SUBMIT,
    sessionTypes.LOGIN_SUBMIT_SUCCESS,
    sessionTypes.SET_SESSION,
    sessionTypes.TIMEOUT_SUCCESS,
    sessionTypes.LOGIN_OAUTH_AUTHORISE_SUCCESS,
    alertsTypes.ALERTS_SHOW_ALERT,
    alertsTypes.ALERTS_HIDE_ALERT,
    trackingTypes.TRACK_PRODUCT_NAVIGATION_CLICK,
    trackingTypes.TRACK_PRODUCT_TOGGLE_CLICK,
    trackingTypes.TRACK_CLICKABLE_HELP_CLICK,
    trackingTypes.TRACK_PREAPPROVED_TOGGLE_CLICK,
    trackingTypes.TRACK_PRODUCT_INTERSTITIAL_PROGRESSION,
    trackingTypes.TRACK_PRODUCT_INTERSTITIAL_COPY_CTA_CLICK,
    trackingTypes.TRACK_PRODUCT_FILTER_APPLIED,
    trackingTypes.TRACK_PRODUCT_FILTER_CLICK,
    trackingTypes.TRACK_PRODUCT_FILTER_UPDATED,
    trackingTypes.TRACK_DONUT_SLIDE_VIEWED,
    trackingTypes.TRACK_DYNAMIC_DASHBOARD_DONUT_CLICKED,
];
